import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.login);

  return isAuthenticated || user ? (
    children
  ) : (
    <Navigate replace to='/login'></Navigate>
  );
};

export default PrivateRoute;
